module.exports = __webpack_public_path__ + "img/qcode.c788cd0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/footer/images/qcode.jpg
// module id = QxAx
// module chunks = 1 4 5 6 15